var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-menu"},[_vm._l((_vm.routes),function(l1){return [(l1.children)?_c('div',{key:l1.path,staticClass:"menu-l2"},[_c('div',[_vm._v(_vm._s(l1.name))]),_vm._l((l1.children),function(l2){return _c('router-link',{key:l1.path + '/' + l2.path,class:{
        'active': _vm.$route.path === l1.path + '/' + l2.path,
      },attrs:{"to":l1.path + '/' + l2.path}},[_vm._v(" "+_vm._s(l2.name)+" ")])})],2):_c('router-link',{key:l1.path,class:{
      'active': _vm.$route.path === l1.path,
    },attrs:{"to":l1.path}},[_vm._v(" "+_vm._s(l1.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }